import * as React from 'react'

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

interface ReviewModalProps {
  closeModal: any,
  numberOfErrors: number,
  numberOfCorrectChanges: number
}

const ReviewModal = ({ closeModal, numberOfErrors, numberOfCorrectChanges, }: ReviewModalProps) => {
  const { modalRef } = useModalAccessibility(closeModal);

  const highScoreMessage = numberOfCorrectChanges > numberOfErrors / 2 ? "Good work! " : null

  return (
    <div
      aria-labelledby='title'
      aria-live="polite"
      aria-modal={true}
      className="review-modal-container"
      ref={modalRef}
      role="dialog"
      tabIndex={-1}
    >
      <div className="review-modal-background" />
      <div className="review-modal">
        <div className="top-section">
          <h1>{highScoreMessage} You found {numberOfCorrectChanges} of {numberOfErrors} errors. Let&#39;s review your edits.</h1>
          <button className="quill-button-archived medium primary contained focus-on-light" onClick={closeModal} type="button">Review</button>
        </div>
      </div>
    </div>
  )
}

export default ReviewModal
